import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { FC } from 'react';

import styles from './SectionTreeItem.module.scss';

export type ItemProps = {
  id: string;
  onClick?: (id: string) => void;
  title: string;
  isLastElement: boolean;
};

export const SectionTreeItem: FC<ItemProps> = (props) => {
  const { id, onClick, title, isLastElement } = props;
  return (
    <div
      key={id}
      className={styles.container}
      data-section-item-link={id}
      onClick={() => onClick?.(id)}
      data-last={isLastElement}
    >
      <div className={styles.contentContainer}>
        <div className={styles.titleContainer}>
          <div className={styles.title}>
            <div className={styles.branch}>
              <div className={styles.verticalLine}>
                <div className={styles.topLine} />
                <div className={styles.bottomLine} />
              </div>
              <div className={styles.horizontalLine} />
            </div>
            {title}
          </div>
        </div>
      </div>
    </div>
  );
};
